module.exports = __webpack_public_path__ + "static/media/FASNYLogoProcess.20c1215c.jpg";